import get from 'lodash/get';
import range from 'lodash/range';
import inRange from 'lodash/inRange';
import isArray from 'lodash/isArray';
import { PAGE_LIMIT } from '@Containers/PatentFamilyClustering/constants';
import htmlStripsService from '@Services/HtmlStripsService';
import PrepareTrackingDataHelper from '@Services/PrepareTrackingDataHelper';

export const isPatent = (document) => {
  return /patent/gi.test(document.type);
};

export const isPatentFamilyGroup = (document) => {
  const { familyId, patentFamilyGroup } = document;
  const count = get(patentFamilyGroup, 'count');
  return isPatent(document) && !!familyId && Number(count) > 1;
};

export const isSinglePatentFromFamily = (document) => {
  const { familyId, patentFamilyGroup } = document;
  const count = get(patentFamilyGroup, 'count');
  return isPatent(document) && !!familyId && Number(count) === 1;
};

export const getCleanFromTags = (str) => {
  return htmlStripsService.getTitleWithoutHtml(str, 'full');
};

export const getCleanFamilyId = (document) => {
  // remove <hi> tags in case of hit data
  return getCleanFromTags(document.familyId);
};

export const getFirstAndLastSubItem = ({ pageNumber, groupCount }) => {
  const firstSubItem = (pageNumber - 1) * PAGE_LIMIT + 1;
  const lastSubItem = Math.min(firstSubItem + PAGE_LIMIT - 1, groupCount);
  return { firstSubItem, lastSubItem };
};

export const getTrackingAttrs =
  ({ metadata, document }) =>
  (trackingAttrs, prepare = true) => {
    return {
      'data-click-delegation': 'true',
      'data-tracking': 'true',
      'data-tracking-context': metadata.context,
      'data-tracking-preview': metadata.isViewPreview,
      'data-tracking-track-link-location-in-results': true,
      'data-tracking-from-rt': metadata.fromRT,
      ...trackingAttrs,
      ...(prepare ? PrepareTrackingDataHelper.prepare(document) : {}),
    };
  };

export const generateRelativeIndex = (mainResultIndex, familyMemberIndex) => {
  return `${mainResultIndex}/${familyMemberIndex}`;
};

export const parseRelativeIndex = (relativeIndex) => {
  return relativeIndex && relativeIndex.split('/');
};

export const generateAbsoluteIndexesInRange = ([firstIndex, lastIndex]) => {
  return range(firstIndex, lastIndex + 1);
};

export const generateCheckedItemsInRange = ([firstIndex, lastIndex], mainResultIndex) => {
  return generateAbsoluteIndexesInRange([firstIndex, lastIndex]).map((absoluteIndexFromRange, _n) => ({
    index: mainResultIndex,
    absoluteIndex: absoluteIndexFromRange,
    relativeIndex: generateRelativeIndex(mainResultIndex, _n + 1),
  }));
};

export const isCheckedResultInRange = ({ absoluteIndex }, [firstIndex, lastIndex]) => {
  return inRange(absoluteIndex, firstIndex, lastIndex + 1);
};

export const absoluteIndexToString = (absoluteIndex) => {
  return isArray(absoluteIndex) ? absoluteIndex.join('-') : String(absoluteIndex);
};
